export const personRefName = 'personRef';

export const personRefProjection = `{
  _id,
  name,
  company,
  jobTitle,
  headshot,
  companyLogo,
  emailAddress,
  bio,
}`;

export const personRefQuery = groq`*[_id == $_id][0] ${personRefProjection}`;
